import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import Api from '../Api/Api'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup'

function VerifyOTP() {
  const location=useLocation()
 const navigate=useNavigate()

  console.log("otp email",location.state)


  const initialValues={
    email:location.state,
    otp1:"",
    otp2:"",
    otp3:"",
    otp4:""
}

const formik=useFormik({
    initialValues:initialValues,
    validationSchema: yup.object({
        // otp1:yup.number().required("Please enter 4 digit OTP)"),
        // otp2:yup.number().required("Please enter 4 digit OTP)"),
        // otp3:yup.number().required("Please enter 4 digit OTP)"),
        otp4:yup.number().required("Please enter 4 digit OTP)")
    }),
    onSubmit:async(values)=>{
        const otp = values.otp1 + values.otp2 + values.otp3 + values.otp4;
        console.log("verify----->", { ...values, otp });
        try {
            const response = await Api.post("/user/verify-reset-password-otp",{ ...values, otp })
            console.log("response---->login+++++",response.data.message)
          //   toast(response.data.message, {
          //     position: "top-right",
          //     autoClose: 2000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          // });

            // localStorage.setItem("Quizetoken-->otp",response.data.message)
            navigate('/resetpassword',{state:{email:values.email,message:response.data.message}})
        } catch (error) {
            console.log(error.response.data.message)
            toast(error.response.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: 'error'
            });
        }
    }
})

  return (
    <>
    <ToastContainer />
    <div className="center">
  <div className="video-form container">
      <div className="row align-items-center">
          <div className="col-lg-5 col-md-12">
              <div className="log-img">
                  <img src="/assets/images/login.png" />
              </div>
          </div>
          <div className="col-lg-7 col-md-12">
            <form onSubmit={formik.handleSubmit}>
              <Link to='/forgot'><i className="fa-solid fa-angle-left" style={{color:'black'}}></i></Link>
              <div className="form-header">
                <h2>Verification</h2>
               
              </div>
              <div className="otp-flex mt-50">
                      <input className="otp" type="text"  name='otp1'  value={formik.values.otp1} onChange={formik.handleChange}  oninput='digitValidate(this)' onkeyup='tabChange(1)' maxlength='1' />
                      <input className="otp" type="text"  name='otp2' value={formik.values.otp2} onChange={formik.handleChange}  oninput='digitValidate(this)' onkeyup='tabChange(2)' maxlength='1' />
                      <input className="otp" type="text"  name='otp3' value={formik.values.otp3} onChange={formik.handleChange}  oninput='digitValidate(this)' onkeyup='tabChange(3)' maxlength='1' />
                      <input className="otp" type="text"  name='otp4' value={formik.values.otp4} onChange={formik.handleChange}  oninput='digitValidate(this)'onkeyup='tabChange(4)' maxlength='1' />
                      
              </div>
                    <div>
                      {formik.touched.otp4 && formik.errors.otp4 ? <div className='text-danger' style={{float: 'right',marginBottom:'7px'}}>{formik.errors.otp4}</div> : null}
                     </div>
              
        
              <button type="submit" className="mt-50"><a> Verify</a></button>
              <a  className="signup-like">Don't get the code? <span> Resend Code</span></a>
            </form>
          </div>
      </div>
      
   
  </div>
</div>
    </>
  )
}

export default VerifyOTP